export const styles = theme => ({
  placeholder: {
    textAlign: 'center'
  },
  tableCell: {
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit
  }
})



// WEBPACK FOOTER //
// ./src/components/Prices/styles.js